// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-date-table td.in-range div[data-v-5f0fa251]{background-color:#ffead7}", ""]);
// Exports
module.exports = exports;
